import { render, staticRenderFns } from "./SearchBoxTipoMulta.vue?vue&type=template&id=0a54aece&scoped=true"
import script from "./SearchBoxTipoMulta.vue?vue&type=script&lang=js"
export * from "./SearchBoxTipoMulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54aece",
  null
  
)

export default component.exports